<template>
  <section class="section-product-detail-page bg-grey">
    <div class="container">
      <div class="row m-0">
        <div class="col-12">
          <div class="content py-0">
            <h2 class="section-title page-title h2 text-center text-black f-44 h2-caslon">Infrastructure</h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">

        <div class="content">
          <ContentsTextWithImage
            title="Infrastructure"
            image-url="/pages/products/industries/infrast.jpg"
            :contents="[
              'Modern infrastructure is including IT, renewable energy, clean water distribution. This innovation will greatly affect consumer behavior and the emerging of new product and service business has to offer. Our plastics are already served in advance communication technology such as 5G & wireless communication devices. Typical plastic properties for 5G applications are stable dk and low df, infrared transparency, ability to metalize, and excellent mechanical strength as devices are getting more compact. In addition, we also supply plastics resin in PV solar component that require good dielectric, non-halogenated FR, dimensional stability. Our plastic material solution used in drinking water distribution are chorine resistance, lead-free, hydrolysis resistant, dimensional stability in hot or cold water, high impact strength and comply with food contact requirement for portable water from international agency like NSF61, WRAS, KTW, W270, ACS',
            ]"
            is-reverse="true"
            is-white-content="true"
            is-content-small-text="true"
            left-width="45.805%"
            right-width="54.195%"
          />
        </div>
        
      </div>
    </div>
  </section>

  <section class="section-gallery bg-grey">

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12 gallery-container">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/f-5g.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">5G antenna components</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/f-oftical.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Optical transceiver</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/f-server.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Cooling fan for 5G server</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12 gallery-container">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/f-pv.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">PV solar junction box</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/f-smart.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Smart meter</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/f-solar.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">PV solar frame</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-show="isMoreGalleryShow">
      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12 gallery-container">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/f-meter.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Water meter</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/f-water.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Water management</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/m-lod.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Faucet cartridge</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/f-water-pump.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Water pump</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="section-product-detail-page pt-4">
      <div class="container page-container">
        <div class="content text-center">
          <button
            class="btn btn-link text-primary text-decoration-none f-15 outline-none"
            @click="handleLoadmoreClick"
          >
            {{ loadMoreButtonText }}
          </button>
        </div>
      </div>
    </section>

  </section>

</template>
<script setup lang="ts">
useHead({
  title:'Infrastructure - NAGASE THAILAND Engineering Plastics',
})

const isMoreGalleryShow = useState<Boolean>('isMoreGalleryShow', () => false)
const loadMoreButtonText = useState<String>('loadMoreButtonText', () => 'Read More')

const handleLoadmoreClick = () => {
  isMoreGalleryShow.value = !isMoreGalleryShow.value
  loadMoreButtonText.value = isMoreGalleryShow.value ? 'Read Less' : 'Read More'
}
</script>
<style scoped>
.page-title {
  padding-bottom: 60px;
}

.section-gallery {
  padding-top: 60px;
  padding-bottom: 60px;
}
</style>